import React, { Dispatch } from "react";
import AlertSimplified from "features/shared/alerts/dtos/AlertSimplified";
import { useDispatch, useSelector } from "react-redux";
import IAppState from "infrastructure/store/IAppState";
import PageAlert from "features/shared/alerts/components/PageAlert";
import {
  AlertsAction,
  removeAlert,
} from "infrastructure/store/alerts/AlertsActions";
import IAlertsState from "infrastructure/store/alerts/IAlertsState";
import AlertParam from "features/shared/alerts/dtos/AlertParam";
import IDataFilterService from "features/shared/components/dataFilter/IDataFilterService";
import { useInjection } from "infrastructure/ioc/ioc.react";
import { IocTypes } from "infrastructure/ioc/ioc.types";

// number of show alerts
const alertsCount = 3;

interface IProps {}

const AlertSection: React.FC<IProps> = () => {
  // DI
  const dataFilterService = useInjection<IDataFilterService>(
    IocTypes.DataFilterService
  );

  // STORE
  const alerts = useSelector<IAppState, IAlertsState>((store) => store.alerts)
    .alerts;

  const alertDispatch = useDispatch<Dispatch<AlertsAction>>();

  // HANDLERS
  const handleAlertOnClose = (alert: AlertSimplified) => {
    if (!alert.alertId) return;
    alertDispatch(removeAlert(alert.alertId));
  };

  const handleOnClickLinkButton = (alertParam?: AlertParam) => {
    if (!alertParam) return;

    const gridId = dataFilterService.getGridIdByRoute(alertParam?.route ?? "");
    if (!gridId) return;

    dataFilterService.storeSetParams(
      gridId,
      undefined,
      new URLSearchParams(alertParam.queryParams)
    );
  };

  return (
    <div>
      {alerts.slice(0, alertsCount).map((alert, index) => (
        <PageAlert
          alertObj={alert}
          closable
          key={alert.alertId}
          onClose={handleAlertOnClose}
          onClickLinkButton={handleOnClickLinkButton}
        />
      ))}
    </div>
  );
};

export default AlertSection;
